import { useEffect, useState } from 'react';
import { Button } from '@features/ui';
import { ExportIcon } from '@features/ui/icons';
import { ReportProfitableTradersTable } from '@features/admin/reports';
import { TReportProfitableTradersRes } from '@src/types/reports';
import {
  exportPAProfitableTraders,
  getPAProfitableTraders,
} from '@src/services/reports.ts';
import { downloadFile } from '@lib/utils.ts';

export const PaProfitableTraders = () => {
  const [data, setData] = useState<TReportProfitableTradersRes | null>(null);
  const [isExporting, setIsExporting] = useState(false);

  const fetchData = async () => {
    try {
      const result = await getPAProfitableTraders();

      setData(result);
    } catch (error) {
      console.error('Error fetching profitable traders:', error);
    }
  };

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const response = await exportPAProfitableTraders();

      downloadFile(response.data, 'pa-profitable-traders');
    } catch (error) {
      console.error('Error exporting data:', error);
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div
        className={
          'flex justify-between lg:items-center gap-7.5 lg:flex-row flex-col'
        }
      >
        <div className={'text-xs flex lg:flex-row flex-col gap-x-8 gap-y-3'}>
          <h1 className={'text-[23px]'}>{`PA Profitable Traders Report`}</h1>
          <p className={'max-w-[419px]'}>
            {data
              ? `Found ${data.total_accounts} active PA accounts with 2+ past payouts`
              : 'Loading...'}
          </p>
        </div>
        <Button
          className={'h-9.5 border-1 border-[#C6C6C6] rounded-[3px] w-fit'}
          disabled={isExporting || !data}
          variant={'outline'}
          onClick={handleExport}
        >
          <p>{isExporting ? 'Exporting...' : 'Export'}</p>
          <ExportIcon />
        </Button>
      </div>
      <ReportProfitableTradersTable data={data?.data ?? []} />
    </div>
  );
};
